import { render, staticRenderFns } from "./FloatingWindow.vue?vue&type=template&id=5c0008f6&scoped=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatingWindow.vue?vue&type=style&index=0&id=5c0008f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0008f6",
  null
  
)

export default component.exports